import React from "react";
import "./Input.css";

const Input = ({
  type = "text",
  value,
  onChange,
  placeholder,
  icon,
  error,
  className = "",
  ...props
}) => (
  <div className="input-wrapper">
    {icon && <span className="input-icon">{icon}</span>}
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`input ${error ? "input-error" : ""} ${className}`.trim()}
      {...props}
    />
    {error && <div className="input-error-message">{error}</div>}
  </div>
);

export default Input;
